import { QueryEntity } from '@datorama/akita';
import { TimeEntriesState, TimeEntriesStore } from './time-entries.store';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TimeEntriesQuery extends QueryEntity<TimeEntriesState> {
  lastPage$ = this.select((state) => state.lastPage);
  total$ = this.select((state) => state.total);

  constructor(protected store: TimeEntriesStore) {
    super(store);
  }
}
